export const GET_ALERT = "GET_ALERT";
export const GET_ALERT_LIST = "GET_ALERT_LIST";
export const ADD_ALERT = "ADD_ALERT";
export const ENABLE_DISABLE_ALERT = "ENABLE_DISABLE_ALERT";
export const ALERT_COMPLETED = "ALERT_COMPLETED";
export const GET_ALERT_TRANSACTION = "GET_ALERT_TRANSACTION";
